import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class VoidExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.VoidExpression;
    }
    visitNode(sb, expr, options) {
        if (options.pushValue) {
            sb.emitHelper(expr, options, sb.helpers.wrapUndefined);
        }
    }
}

//# sourceMappingURL=VoidExpressionCompiler.js.map
